import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";

import "./asset-timeline-scroll-loader.style.less";

const { Text } = Typography;

export const AssetTimelineScrollLoader = () => {
  const { t } = useTranslation();

  return (
    <div className="timeline-scroll-loader">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} />} />
      <Text>{t("global:loading")}</Text>
    </div>
  );
};
